// extracted by mini-css-extract-plugin
export default {"AssessmentFor":"AssessmentFor_AssessmentFor__y6bhJ","title":"AssessmentFor_title__b0iY0","content":"AssessmentFor_content__GeHs2"};